import { render, staticRenderFns } from "./FormulateVueSelect.vue?vue&type=template&id=4f56fdfd&"
import script from "./FormulateVueSelect.vue?vue&type=script&lang=js&"
export * from "./FormulateVueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports